import DashboardPageLayout from "../pages/master/MasterPageLayout";
import { RouteType } from "./config";
import DashboardIndex from "../pages/master/MasterPageIndex";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import HomeIcon from "@mui/icons-material/Home";
import ZoneMaster from "../pages/master/ZoneMaster/ZoneMaster";
import ZoneMasterAdd from "../pages/master/ZoneMaster/ZoneMasterAdd";
import ZoneMasterEdit from "../pages/master/ZoneMaster/ZoneMasterEdit";
import DepartmentMaster from "../pages/master/DepartmentMaster/DepartmentMaster";
import DesignationMaster from "../pages/master/DesignationMaster/DesignationMaster";
import DesignationMasterAdd from "../pages/master/DesignationMaster/DesignationMasterAdd";
import DesignationMasterEdit from "../pages/master/DesignationMaster/DesignationMasterEdit";
import LoginPage from "../loginPage/LoginPage";
import HomePage from "../pages/home/HomePage";
import WardMaster from "../pages/master/WardMaster/WardMaster";
import WardMasterAdd from "../pages/master/WardMaster/WardMasterAdd";
import WardMasterEdit from "../pages/master/WardMaster/WardMasterEdit";
import DepartmentAdd from "../pages/master/DepartmentMaster/DepartmentAdd";
import DepartmentEdit from "../pages/master/DepartmentMaster/DepartmentEdit";
import AdvertisementReports from "../pages/reports/AdvertisementReports/AdvertisementReports";
import CaseReports from "../pages/reports/CaseReports/CaseReports";
import AdvertisementLocationReports from "../pages/reports/AdvertisementLocationReports/AdvertisementLocationReports";
import TenderReports from "../pages/reports/TenderReports/TenderReports";
// import VendorPaymentReport from "../pages/reports/VendorPaymentReport/VendorPaymentReport";
import FileAssigning from "../pages/DocManagement/FileAssigning/FileAssigning";
import IssueReturn from "../pages/DocManagement/IssueReturn/IssueReturn";
import CityMaster from "../pages/master/CityMaster/CityMaster";
import CityMasterAdd from "../pages/master/CityMaster/CityMasterAdd";
import CityMasterEdit from "../pages/master/CityMaster/CityMasterEdit";
import StateMaster from "../pages/master/StateMaster/StateMaster";
import StateMasterAdd from "../pages/master/StateMaster/StateMasterAdd";
import StateMasterEdit from "../pages/master/StateMaster/StateMasterEdit";
import GenderMaster from "../pages/master/GenderMaster/GenderMaster";
import GenderMasterAdd from "../pages/master/GenderMaster/GenderMasterAdd";
import GenderMasterEdit from "../pages/master/GenderMaster/GenderMasterEdit";
import CountryMaster from "../pages/master/CountryMaster/CountryMaster";
import CountryMasterAdd from "../pages/master/CountryMaster/CountryMasterAdd";
import CountryMasterEdit from "../pages/master/CountryMaster/CountryMasterEdit";
import UserManagement from "../pages/UserManagementMaster/UserManagement/UserManagement";
import UserManagementAdd from "../pages/UserManagementMaster/UserManagement/UserManagementAdd";
import UserManagementEdit from "../pages/UserManagementMaster/UserManagement/UserManagementEdit";
import UserType from "../pages/UserManagementMaster/UserType/UserType";
import RoleMaster from "../pages/UserManagementMaster/RoleMaster/RoleMaster";
import UserPermissionMaster from "../pages/UserManagementMaster/UserPermissionMaster/UserPermissionMaster";
import MenuMaster from "../pages/master/Menu/MenuMaster";
import MenuMasterAdd from "../pages/master/Menu/MenuMasterAdd";
import MenuMasterEdit from "../pages/master/Menu/MenuMasterEdit";
import EmployeeMaster from "../pages/Employee/EmployeeMaster";
import EmployeeAdd from "../pages/Employee/EmployeeAdd";
import EmployeeEdit from "../pages/Employee/EmployeeEdit";

import FileGroup from "../pages/DocManagement/FileGroup/FileGroup";
import FileSubject from "../pages/DocManagement/FileSubject/FileSubject";
import FileType from "../pages/DocManagement/FileType/FileType";

import ReceiptStatus from "../pages/DocManagement/ReceiptStatus/ReceiptStatus";
import ReceiptType from "../pages/DocManagement/ReceiptType/ReceiptType";
import Location from "../pages/DocManagement/Location/Location";
import ReqForm from "../pages/DocManagement/ReqForm/ReqForm";
import ReqFormAdd from "../pages/DocManagement/ReqForm/ReqFormAdd";
import ReqFormEdit from "../pages/DocManagement/ReqForm/ReqFormEdit";
import DocType from "../pages/DocManagement/DocType/DocType";
import DocTypeAdd from "../pages/DocManagement/DocType/DocTypeAdd";
import DocTypeEdit from "../pages/DocManagement/DocType/DocTypeEdit";
import DocSubject from "../pages/DocManagement/DocSubject/DocSubject";

import DocDetail from "../pages/DocManagement/DocDetail/DocDetail";
import DocDetailAdd from "../pages/DocManagement/DocDetail/DocDetailAdd";
import DocDetailEdit from "../pages/DocManagement/DocDetail/DocDetailEdit";

// import DocPdf from "../pages/DocManagement/UpdatePDFFile/UpdatePDF";

import DocViewer from "../pages/DocManagement/DocViewer/DocViewer";
import DocViewerAdd from "../pages/DocManagement/DocViewer/DocViewerAdd";
import DocViewerEdit from "../pages/DocManagement/DocViewer/DocViewerEdit";
import PdfCounter from "../pages/DocManagement/PdfCounter/PdfCounter";
import DocFiles from "../pages/DocManagement/DocFiles/DocFiles";
import DocFilesAdd from "../pages/DocManagement/DocFiles/DocFilesAdd";
import DocFilesEdit from "../pages/DocManagement/DocFiles/DocFilesEdit";
import DocPages from "../pages/DocManagement/DocPages/DocPages";
import DocPagesAdd from "../pages/DocManagement/DocPages/DocPagesAdd";
import DocPagesEdit from "../pages/DocManagement/DocPages/DocPagesEdit";
import Document from "../pages/DocManagement/Document/Document";
import DocumentAdd from "../pages/DocManagement/Document/DocumentAdd";
import DocumentEdit from "../pages/DocManagement/Document/DocumentEdit";
import DocSubSubject from "../pages/DocManagement/DocSubSubject/DocSubSubject";
import DocumentEntry from "../pages/DocManagement/DocumentEntry/DocumentEntry";
import DocumentEntryAdd from "../pages/DocManagement/DocumentEntry/DocumentEntryAdd";
import DocumentEntryEdit from "../pages/DocManagement/DocumentEntry/DocumentEntryEdit";

// import SplitPDF from "../pages/DocManagement/SplitPDFToJump/SplitPDF";
import DocMng from "../pages/DocManagement/DocMng/DocMng";
import DocMngAdd from "../pages/DocManagement/DocMng/DocMngAdd";
import DocMngEdit from "../pages/DocManagement/DocMng/DocMngEdit";
import DocManagerReports from "../pages/reports/DocManagerReports/DocManagerReports";
import DocumentReports from "../pages/reports/DocumentReports/DocumentIndexing";
import DocumentIndexing from "../pages/reports/DocumentReports/DocumentIndexing";
import SplitPDF from "../pages/DocManagement/SplitPDFToJump/SplitPDF";
import UpdatePDF from "../pages/DocManagement/UpdatePDFFile/UpdatePDF";
import SplitPage from "../pages/DocManagement/SplitPDFToJump/SplitPage";
import JobManagement from "../pages/JobManagement/JobManagement";
import HelpCreation from "../pages/HelpCreation/HelpCreation";
import HelpDesk from "../pages/HelpDesk/HelpDesk";
import SplitFileView from "../pages/DocManagement/SplitPDFToJump/SplitFileView";
import SubDepartmentMaster from "../pages/master/SubDepartmentMaster/SubDepartmentMaster";
import SubDepartmentAdd from "../pages/master/SubDepartmentMaster/SubDepartmentAdd";
import SubDepartmentEdit from "../pages/master/SubDepartmentMaster/SubDepartmentEdit";
import NewNodeMaster from "../pages/master/NewNodeMaster/NewNodeMaster";
// import UpdatePDF from "../pages/DocManagement/UpdatePDFFile/UpdatePDF";






const appRoutes: RouteType[] = [
  {
    index: true,
    element: <LoginPage />,
    state: "home",
  },
  {
    element: <HomePage />,
    state: "home",
    path: "/home",
    sidebarProps: {
      displayText: "Home",
      icon: <HomeIcon />,
    },
  },

  {
    element: <JobManagement />,
    state: "JobManagement",
    path: "/JobManagement",
    sidebarProps: {
      displayText: "Job Management",

    },
  },
  {
    path: "/master",
    element: <DashboardPageLayout />,
    state: "master",
    sidebarProps: {
      displayText: "Master",
      icon: <DashboardOutlinedIcon />,
    },
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "master.index",
      },
      {
        path: "/master/ZoneMaster",
        element: <ZoneMaster />,
        state: "master.ZoneMaster",
        sidebarProps: {
          displayText: "Zone Master",
        },
      },
      {
        path: "/master/ZoneMasterAdd",
        element: <ZoneMasterAdd />,
        state: "master.ZoneMasterAdd",
      },
      {
        path: "/master/ZoneMasterEdit",
        element: <ZoneMasterEdit />,
        state: "master.ZoneMasterEdit",
      },
      {
        path: "/master/WardMaster",
        element: <WardMaster />,
        state: "master.WardMaster",
        sidebarProps: {
          displayText: "Ward Master",
        },
      },
      {
        path: "/master/WardMasterAdd",
        element: <WardMasterAdd />,
        state: "master.WardMasterAdd",
      },
      {
        path: "/master/WardMasterEdit",
        element: <WardMasterEdit />,
        state: "master.WardMasterEdit",
      },
      {
        path: "/master/DepartmentMaster",
        element: <DepartmentMaster />,
        state: "master.DepartmentMaster",
        sidebarProps: {
          displayText: "Department Master",
        },
      },
      {
        path: "/master/DepartmentAdd",
        element: <DepartmentAdd />,
        state: "master.DepartmentAdd",
      },
      {
        path: "/master/DepartmentEdit",
        element: <DepartmentEdit />,
        state: "master.DepartmentEdit",
      },

      {
        path: "/master/DesignationMaster",
        element: <DesignationMaster />,
        state: "master.DesignationMaster",
        sidebarProps: {
          displayText: "Designation Master",
        },
      },
      {
        path: "/master/DesignationMasterAdd",
        element: <DesignationMasterAdd />,
        state: "master.DesignationMasterAdd",
      },
      {
        path: "/master/DesignationMasterEdit",
        element: <DesignationMasterEdit />,
        state: "master.DesignationMasterEdit",
      },
      {
        path: "/master/CityMaster",
        element: <CityMaster />,
        state: "master.CityMaster",
        sidebarProps: {
          displayText: "District",
        },
      },
      {
        path: "/master/CityMasterAdd",
        element: <CityMasterAdd />,
        state: "master.CityMasterAdd",
      },
      {
        path: "/master/CityMasterEdit",
        element: <CityMasterEdit />,
        state: "master.CityMasterEdit",
      },
      {
        path: "/master/StateMaster",
        element: <StateMaster />,
        state: "master.StateMaster",
        sidebarProps: {
          displayText: "State",
        },
      },
      {
        path: "/master/StateMasterAdd",
        element: <StateMasterAdd />,
        state: "master.StateMasterAdd",
      },
      {
        path: "/master/StateMasterEdit",
        element: <StateMasterEdit />,
        state: "master.StateMasterEdit",
      },
      {
        path: "/master/GenderMaster",
        element: <GenderMaster />,
        state: "master.GenderMaster",
        sidebarProps: {
          displayText: "Gender",
        },
      },
      {
        path: "/master/GenderMasterAdd",
        element: <GenderMasterAdd />,
        state: "master.GenderMasterAdd",
      },
      {
        path: "/master/GenderMasterEdit",
        element: <GenderMasterEdit />,
        state: "master.GenderMasterEdit",
      },
      {
        path: "/master/CountryMaster",
        element: <CountryMaster />,
        state: "master.CountryMaster",
        sidebarProps: {
          displayText: "Country",
        },
      },
      {
        path: "/master/CountryMasterAdd",
        element: <CountryMasterAdd />,
        state: "master.CountryMasterAdd",
      },
      {
        path: "/master/CountryMasterEdit",
        element: <CountryMasterEdit />,
        state: "master.CountryMasterEdit",
      },
      {
        path: "/master/MenuMaster",
        element: <MenuMaster />,
        state: "master.MenuMaster",
        sidebarProps: {
          displayText: "Menu Master",
        },
      },
      {
        path: "/master/MenuMasterAdd",
        element: <MenuMasterAdd />,
        state: "master.MenuMasterAdd",
      },
      {
        path: "/master/MenuMasterEdit",
        element: <MenuMasterEdit />,
        state: "master.MenuMasterEdit",
      },
      {
        path: "/master/SubDepartmentMaster",
        element: <SubDepartmentMaster />,
        state: "master.SubDepartmentMaster",
        sidebarProps: {
          displayText: "SubDepartment Master",
        },
      },
      {
        path: "/master/SubDepartmentAdd",
        element: <SubDepartmentAdd />,
        state: "master.SubDepartmentAdd",
      },
      {
        path: "/master/SubDepartmentEdit",
        element: <SubDepartmentEdit />,
        state: "master.SubDepartmentEdit",
      },
      {
        path: "/master/NewNodeMaster",
        element: <NewNodeMaster />,
        state: "master.NewNodeMaster",
        sidebarProps: {
          displayText: "NewNodeMaster",
        },
      },
    ],
  },
  //======================Master Form End========================


  //==================Start DocManagement====================
  {
    path: "/DocManagement",
    element: <DashboardPageLayout />,
    state: "DocManagement",
    child: [
      {
        path: "/DocManagement/FileAssigning",
        element: <FileAssigning />,
        state: "DocManagement.FileAssigning",
        sidebarProps: {
          displayText: "File Assigning",
        },
      },

      {
        path: "/DocManagement/IssueReturn",
        element: <IssueReturn />,
        state: "DocManagement.IssueReturn",
        sidebarProps: {
          displayText: "Issue Return",
        },
      },
      {
        path: "/DocManagement/DocType",
        element: <DocType />,
        state: "DocManagement.DocType",
        sidebarProps: {
          displayText: "Doc type",
        },
      },

      {
        path: "/DocManagement/DocTypeAdd",
        element: <DocTypeAdd />,
        state: "DocManagement.DocTypeAdd",

      },
      {
        path: "/DocManagement/DocTypeEdit",
        element: <DocTypeEdit />,
        state: "DocManagement.DocTypeEdit",

      },
      {
        path: "/DocManagement/FileGroup",
        element: <FileGroup />,
        state: "DocManagement.FileGroup",
        sidebarProps: {
          displayText: "File Group",
        },
      },
      {
        path: "/DocManagement/FileSubject",
        element: <FileSubject />,
        state: "DocManagement.FileSubject",
        sidebarProps: {
          displayText: "File Subject",
        },
      },
      {
        path: "/DocManagement/FileType",
        element: <FileType />,
        state: "DocManagement.FileType",
        sidebarProps: {
          displayText: "File Type",
        },
      },

      {
        path: "/DocManagement/DocDetail",
        element: <DocDetail />,
        state: "DocManagement.DocDetail",
        sidebarProps: {
          displayText: "Doc Detail",
        },
      },

      {
        path: "/DocManagement/DocDetailAdd",
        element: <DocDetailAdd />,
        state: "DocManagement.DocDetailAdd",

      },

      {
        path: "/DocManagement/DocDetailEdit",
        element: <DocDetailEdit />,
        state: "DocManagement.DocDetailEdit",

      },

      {
        path: "/DocManagement/ReceiptStatus",
        element: <ReceiptStatus />,
        state: "DocManagement.ReceiptStatus",
        sidebarProps: {
          displayText: "Receipt Status",
        },
      },

      {
        path: "/DocManagement/ReceiptType",
        element: <ReceiptType />,
        state: "DocManagement.ReceiptType",
        sidebarProps: {
          displayText: "Receipt Type",
        },
      },

      {
        path: "/DocManagement/Location",
        element: <Location />,
        state: "DocManagement.Location",
        sidebarProps: {
          displayText: "Location",
        },
      },

      {
        path: "/DocManagement/ReqForm",
        element: <ReqForm />,
        state: "DocManagement.ReqForm",
        sidebarProps: {
          displayText: "ReqForm",
        },
      },

      {
        path: "/DocManagement/ReqFormAdd",
        element: <ReqFormAdd />,
        state: "DocManagement.ReqFormAdd",

      },

      {
        path: "/DocManagement/ReqFormEdit",
        element: <ReqFormEdit />,
        state: "DocManagement.ReqFormEdit",

      },

      {
        path: "/DocManagement/DocSubject",
        element: <DocSubject />,
        state: "DocManagement.DocSubject",
        sidebarProps: {
          displayText: "DocSubject",
        },
      },
      {
        path: "/DocManagement/DocSubSubject",
        element: <DocSubSubject />,
        state: "DocManagement.DocSubSubject",
        sidebarProps: {
          displayText: "DocSubSubject",
        },
      },
      {
        path: "/DocManagement/DocumentEntry",
        element: <DocumentEntry />,
        state: "DocManagement.DocumentEntry",
        sidebarProps: {
          displayText: "DocumentEntry",
        },
      },
      {
        path: "/DocManagement/DocumentEntryEdit",
        element: <DocumentEntryEdit />,
        state: "DocManagement.DocumentEntryEdit",
        sidebarProps: {
          displayText: "DocumentEntryEdit",
        },
      },
      {
        path: "/DocManagement/DocumentEntryAdd",
        element: <DocumentEntryAdd />,
        state: "DocManagement.DocumentEntryAdd",
        sidebarProps: {
          displayText: "DocumentEntryAdd",
        },
      },
      {
        path: "/DocManagement/SplitPDFToJump",
        element: <SplitPDF />,
        state: "DocManagement.SplitPDFToJump",
        sidebarProps: {
          displayText: "SplitPDFToJump",
        },
      },
      {
        path: "/DocManagement/SplitPage",
        element: <SplitPage />,
        state: "DocManagement.SplitPage",

      },
      {
        path: "/DocManagement/DocMng",
        element: <DocMng />,
        state: "DocManagement.DocMng",
        sidebarProps: {
          displayText: "DocMng",
        },
      },

      {
        path: "/DocManagement/DocMngAdd",
        element: <DocMngAdd />,
        state: "DocManagement.DocMngAdd",

      },



      {
        path: "/DocManagement/DocMngEdit",
        element: <DocMngEdit />,
        state: "DocManagement.DocMngEdit",

      },

      {
        path: "/DocManagement/UpdatePDF",
        element: <UpdatePDF />,
        state: "DocManagement.UpdatePDF",
        sidebarProps: {
          displayText: "UpdatePDF",
        },
      },

      {
        path: "/DocManagement/DocViewer",
        element: <DocViewer />,
        state: "DocManagement.DocViewer",
        sidebarProps: {
          displayText: "DocViewer",
        },
      },

      {
        path: "/DocManagement/DocViewerAdd",
        element: <DocViewerAdd />,
        state: "DocManagement.DocViewerAdd",

      },



      {
        path: "/DocManagement/DocViewerEdit",
        element: <DocViewerEdit />,
        state: "DocManagement.DocViewerEdit",

      },
      {
        path: "/DocManagement/DocumentIndexing",
        element: <DocumentIndexing />,
        state: "DocManagement.DocumentIndexing",
        sidebarProps: {
          displayText: "Document Indexing",
        },
      },
      {
        path: "/DocManagement/PdfCounter",
        element: <PdfCounter />,
        state: "DocManagement.PdfCounter",
        sidebarProps: {
          displayText: "PdfCounter",
        },
      },

      {
        path: "/DocManagement/DocFiles",
        element: <DocFiles />,
        state: "DocManagement.DocFiles",
        sidebarProps: {
          displayText: "DocFiles",
        },
      },

      {
        path: "/DocManagement/DocFilesAdd",
        element: <DocFilesAdd />,
        state: "DocManagement.DocFilesAdd",

      },



      {
        path: "/DocManagement/DocFilesEdit",
        element: <DocFilesEdit />,
        state: "DocManagement.DocFilesEdit",

      },

      {
        path: "/DocManagement/DocPages",
        element: <DocPages />,
        state: "DocManagement.DocPages",
        sidebarProps: {
          displayText: "DocPages",
        },
      },

      {
        path: "/DocManagement/DocPagesAdd",
        element: <DocPagesAdd />,
        state: "DocManagement.DocPagesAdd",

      },



      {
        path: "/DocManagement/DocPagesEdit",
        element: <DocPagesEdit />,
        state: "DocManagement.DocPagesEdit",

      },


      {
        path: "/DocManagement/Document",
        element: <Document />,
        state: "DocManagement.Document",
        sidebarProps: {
          displayText: "Document",
        },
      },

      {
        path: "/DocManagement/DocumentAdd",
        element: <DocumentAdd />,
        state: "DocManagement.DocumentAdd",

      },
      {
        path: "/DocManagement/DocumentEdit",
        element: <DocumentEdit />,
        state: "DocManagement.DocumentEdit",

      },

      {
        path: "/DocManagement/SplitFileView",
        element: <SplitFileView />,
        state: "DocManagement.SplitFileView",
        sidebarProps: {
          displayText: "Split File View",
        },
      },











    ],
  },
  //===================End Library===================

  /////-------------------start ------UserManagement-----------------------

  {
    path: "/UserManagement",
    element: <DashboardPageLayout />,
    state: "UserManagement",
    sidebarProps: {
      displayText: "User Management",
      icon: <DashboardOutlinedIcon />
    },
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "UserManagement.index",
      },

      {
        path: "/UserManagement/UserManagement",
        element: <UserManagement />,
        state: "UserManagement.UserManagement",
        sidebarProps: {
          displayText: "User Management  Master",
        }
      },
      {
        path: "/UserManagement/UserManagementAdd",
        element: <UserManagementAdd />,
        state: "UserManagement.UserManagementAdd",
        // sidebarProps: {
        //   displayText: "Advertisement Entry Add",
        // }
      },
      {
        path: "/UserManagement/UserManagementEdit",
        element: <UserManagementEdit />,
        state: "UserManagement.UserManagementEdit",

      },
      // UserType
      {
        path: "/UserManagement/UserType",
        element: <UserType />,
        state: "UserManagement.UserType",
        sidebarProps: {
          displayText: "User Type",
        }
      },
      {
        path: "/UserManagement/RoleMaster",
        element: <RoleMaster />,
        state: "UserManagement.RoleMaster",
        sidebarProps: {
          displayText: "Role Master",
        },
      },
      {
        path: "/UserManagement/UserPermissionMaster",
        element: <UserPermissionMaster />,
        state: "UserManagement.UserPermissionMaster",
        sidebarProps: {
          displayText: "User Permission",
        },
      },
    ]

  },

  //==================end========UserManagement==========

  //==================== Start Employee Information====================
  {
    path: "/Employee",
    element: <DashboardPageLayout />,
    state: "Employee",
    sidebarProps: {
      displayText: "Employee",
      icon: <DashboardOutlinedIcon />,
    },
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "employeeinfo.index",
      },
      {
        path: "/Employee/EmployeeMaster",
        element: <EmployeeMaster />,
        state: "Employee.EmployeeMaster",
        sidebarProps: {
          displayText: "Employee Master",
        },
      },
      {
        path: "/Employee/EmployeeAdd",
        element: <EmployeeAdd />,
        state: "Employee.EmployeeAdd",
      },
      {
        path: "/Employee/EmployeeEdit",
        element: <EmployeeEdit />,
        state: "Employee.EmployeeEdit",
      },

    ],
  },
  //==================Start Correction=========Desable hai===========

  //==================Start Report=========Desable hai===========
  {
    path: "/Reports",
    element: <DashboardPageLayout />,
    state: "Reports",
    child: [
      {
        path: "/Reports/AdvertisementReports",
        element: <AdvertisementReports />,
        state: "Reports.AdvertisementReports",
        sidebarProps: {
          displayText: "Advertisement Reports",
        },
      },

      {
        path: "/Reports/DocManagerReports",
        element: <DocManagerReports />,
        state: "Reports.DocManagerReports",
        sidebarProps: {
          displayText: "Doc Manager Reports",
        },
      },

      {
        path: "/Reports/AdvertisementLocationReports",
        element: <AdvertisementLocationReports />,
        state: "Reports.AdvertisementLocationReports",
        sidebarProps: {
          displayText: "Advertisement Location Reports",
        },
      },
      // {
      //   path: "/Reports/VendorPaymentReport",
      //   element: <VendorPaymentReport />,
      //   state: "Reports.VendorPaymentReport",
      //   sidebarProps: {
      //     displayText: "Vendor Payment Report",
      //   },
      // },
    ],
  },


  {
    path: "/Help",
    element: <DashboardPageLayout />,
    state: "Help",
    child: [
      {
        path: "/Help/HelpCreation",
        element: <HelpCreation />,
        state: "Help.HelpCreation",
        sidebarProps: {
          displayText: "Help Creation",
        },
      },

      {
        path: "/Help/HelpDesk",
        element: <HelpDesk />,
        state: "Help.HelpDesk",
        sidebarProps: {
          displayText: "Help Desk",
        },
      },


    ],
  },

  // {
  //   path: "/settings",
  //   element: <SettingsPage />,
  //   state: "settings",
  //   sidebarProps: {
  //     displayText: "Settings",
  //     icon: <FormatListBulletedOutlinedIcon />
  //   }
  // }
];

export default appRoutes;